import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { UseCase } from '../models/use-case.model';

@Injectable({
  providedIn: 'root'
})
export class UseCasesService {
  private readonly dataUrl = 'assets/data/use-cases.json';

  constructor(private readonly http: HttpClient) {}

  getUseCases(): Observable<UseCase[]> {
    return this.http.get<UseCase[]>(this.dataUrl);
  }
}
